export const Roles = {
    ADMIN: 'ADMIN',
    MODERATOR: 'MODERATOR',
    ACCOUNTANT: 'ACCOUNTANT',
};